import { Box, Typography, Grid } from '@mui/material';
import { Button } from '@components/button';

export interface INoResults {
  title?: string;
  subtitle?: string;
  clearFilters?: () => void;
}
interface INoResultsOverlay {
  noResultsMsg: INoResults;
  onViewAllClick?: () => void;
  buttonText?: string;
  buttonVariant?: 'text' | 'outlined' | 'contained';
}

// TODO => COLORS into palette theme 6/19

export const NoResultsOverlay = ({
  noResultsMsg,
  onViewAllClick,
  buttonText,
  buttonVariant = 'outlined',
}: INoResultsOverlay) => {
  const { title, subtitle } = noResultsMsg;

  return (
    <Grid
      id='no-results-overlay'
      sx={{
        p: 4,
        flexDirection: 'column',
        zIndex: '5',
        backgroundColor: 'background.light',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        id='no-results-overlay-content'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
        }}
      >
        {/* EC above is keeping the space the grid overlay margin 0 used to have, but for some reason was ignoring background color */}
        {title ? (
          <Typography
            variant='h4'
            sx={{
              marginBottom: '12px',
              textAlign: 'center',
            }}
          >
            {title}
          </Typography>
        ) : null}
        {subtitle ? <Typography variant='bodySmall'>{subtitle}</Typography> : null}
        {title?.includes('matches') || buttonText ? (
          <Button
            variant={buttonVariant}
            sx={{
              pointerEvents: 'auto',
              mb: 1,
            }}
            onClick={onViewAllClick}
          >
            {buttonText ?? 'View all records instead?'}
          </Button>
        ) : null}
      </Box>
    </Grid>
  );
};
